import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivateComponent } from "./pages/activate/activate.component";
import { AccountComponent } from "./pages/account/account.component";
import { authGuard } from "./services/auth.guard";
import {SurveyComponent} from "./pages/survey/survey.component";
import {PollsComponent} from "./pages/polls/polls.component";
import {FavoritesComponent} from "./pages/favorites/favorites.component";
import {OrdersHistoryNewComponent} from "./pages/orders-history-new/orders-history-new.component";
import {OrdersComponent} from "./pages/orders/orders.component";
import {PersonalComponent} from "./pages/personal/personal.component";
import {DeletedComponent} from "./pages/deleted/deleted.component";
import {BasketComponent} from "./pages/basket/basket.component";
import {SiteBlockedComponent} from "./pages/site-blocked/site-blocked.component";
import {BasketConfirmComponent} from "./pages/basket-confirm/basket-confirm.component";
import {GoodComponent} from "./pages/good/good.component";

const routes: Routes = [
  {
    path: 'deleted',
    component: DeletedComponent,
  },

  {
    path: 'site_blocked',
    component: SiteBlockedComponent,
  },

  {
    path: 'activate',
    component: ActivateComponent,
  },

  {
    path: 'account',
    component: AccountComponent,
    canActivate: [authGuard]
  },

  {
    path: 'survey',
    component: SurveyComponent,
    canActivate: [authGuard]
  },

  {
    path: 'polls',
    component: PollsComponent,
    canActivate: [authGuard]
  },

  {
    path: 'favorites',
    component: FavoritesComponent,
    data: { type: 4 },
    canActivate: [authGuard]
  },

  {
    path: 'orders_history_new',
    component: OrdersHistoryNewComponent,
    data: { type: 1 },
    canActivate: [authGuard]
  },

  {
    path: 'orders_history_nalojki',
    component: OrdersHistoryNewComponent,
    data: { type: 2 },
    canActivate: [authGuard]
  },

  {
    path: 'orders',
    component: OrdersComponent,
    data: { type: 3 },
    canActivate: [authGuard]
  },

  {
    path: 'personal',
    component: PersonalComponent,
    data: { type: 5 },
    canActivate: [authGuard]
  },

  {
    path: 'basket',
    component: BasketComponent,
    canActivate: [authGuard]
  },

  {
    path: 'basket_confirm',
    component: BasketConfirmComponent,
    canActivate: [authGuard]
  },

  {
    path: 'good/:id',
    component: GoodComponent,
    canActivate: [authGuard]
  },

  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'account'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
